export default __webpack_public_path__ + "static/media/cross.15837238.png";